import angular from "angular";
import filters from "./filters";
import templateFilters from "./templateFilters";
var moduleNames = [filters, templateFilters].map(function (module) {
    return module.name;
});

export default angular.module("sbApp.allFilters", moduleNames);
